"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeuteriumExport = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Card_1 = require("../Card");
const LogHelper_1 = require("../../LogHelper");
class DeuteriumExport extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.DEUTERIUM_EXPORT,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.VENUS, Tags_1.Tags.ENERGY],
            cost: 11,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: '221',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 Floater to this card.', (eb) => {
                        eb.empty().startAction.floaters(1);
                    }).br;
                    b.or(Size_1.Size.SMALL).br;
                    b.action('Spend 1 Floater here to increase your energy production 1 step.', (be) => {
                        be.floaters(1).startAction.production((pb) => pb.energy(1));
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        if (this.resourceCount < 1) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        return new OrOptions_1.OrOptions(new SelectOption_1.SelectOption('Remove 1 floater to raise energy production 1 step', 'Remove floater', () => {
            this.resourceCount--;
            LogHelper_1.LogHelper.logRemoveResource(player, this, 1, 'increase energy production 1 step');
            player.addProduction(Resources_1.Resources.ENERGY, 1);
            return undefined;
        }), new SelectOption_1.SelectOption('Add 1 floater to this card', 'Add floater', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        }));
    }
}
exports.DeuteriumExport = DeuteriumExport;
//# sourceMappingURL=DeuteriumExport.js.map